//templates
let terms_agreed = false;


function tryOnInit(initFitmixInstance = true, initOnlyFitmix = false) {
    let TRY_ON_DEBUG = false; // skips chat
    let skipChat = false;
    const MOBILE_MAX_SIZE = 1240; // in pixels

    var myFitmixContainer = document.getElementById("fittingbox-collection-page");
    if (myFitmixContainer) {
        //types: normal, typing, choice-container
        let $chatMessageTemplate = $('script[data-template="chat-message"]').text().split(/\$\{(.+?)\}/g);
        let $chatMessageTypingTemplate = $('script[data-template="chat-message-typing"]').text().split(/\$\{(.+?)\}/g);
        let $chatChoiceTemplate = $('script[data-template="chat-choice-container"]').text().split(/\$\{(.+?)\}/g);
        let $chatChoiceTemplate2 = $('script[data-template="chat-choice-container-2"]').text().split(/\$\{(.+?)\}/g);

        const selectors = {
            chatContainer: "[data-chat-container]",
            facetsForm: "#FacetChatFiltersFormChat",
            typing: "[data-chat-typing]",
            collections: "[data-collections]",
            collectionsShape: "[data-collections-shape]",
            choiceContainer: {
                parent: "[data-choice-container]",
                item: "[data-glasses-item]",
                itemText: "[data-glasses-item-text]",
                itemImg: "[data-glasses-item-img]",
                itemWrapper: "[data-glasses-item-wrapper]"
            }
        }

        checkSkipChat();

        //init
        $(() => {
            if (!TRY_ON_DEBUG) {
                initIntro();
            } else {
                if (initFitmixInstance) {
                    initFitMix();
                    toggleIntroModal();
                    $("#my-fitmix-container").show();
                    $(".fittingbox-product-list-wrapper").show();
                    $(selectors.chatContainer).remove();
                } else {
                    onFitMixReady();
                }
            }

            //executed when filter applied
            if (initOnlyFitmix) {
                onFitMixReady();
            } else {
                initChat();
            }
        });

        function checkSkipChat() {
            const queryString = document.location.search;
            const urlParams = new URLSearchParams(queryString);
            if (urlParams.get("skip-chat") == 'true') {
                skipChat = true;
                initOnlyFitmix = true;
                TRY_ON_DEBUG = true;
            }
        }

        function initIntro() {
            $(".intro-container").find(".feather-x").on("click", toggleIntroModal);
        }

        function toggleIntroModal() {
            $(".intro-container").toggle();
        }

        function initChat() {
            addChatMessage("normal", [{ text: shopifyData.welcomeMessage }], true, 1000);
            addChatMessageWithDelay("glasses-choice-container", null, null, null, 2000);
        }

        //delay in ms
        function addChatMessageWithDelay(type, messageData, showTypingAnim, typingTime, delay) {
            setTimeout(() => {
                addChatMessage(type, messageData, showTypingAnim, typingTime)
            }, delay);
        }

        /**
         * Render a chat message
         * @param {string} type normal | typing | glasses-choice-container | shape-choice-container
         * @param {string} messageData props ex [{text: foo}]
         * @param {boolean} showTypingAnim 
         * @param {int} typingTime in ms 
         */
        function addChatMessage(type, messageData, showTypingAnim, typingTime) {
            let messageTemplate;
            let facetsForm = selectors.facetsForm;

            //types
            switch (type) {
                case "normal":
                    messageTemplate = $chatMessageTemplate;
                    break;
                case "typing":
                    messageTemplate = $chatMessageTypingTemplate;
                    break;
                case "glasses-choice-container":
                    messageTemplate = $chatChoiceTemplate;
                    break;
                case "shape-choice-container":
                    messageTemplate = $chatChoiceTemplate2;
                    break;
                default:
                    break;
            }

            //typing
            if (showTypingAnim) {
                appendChatHtml(facetsForm, $chatMessageTypingTemplate);
                setTimeout(() => {
                    removeTypingHtml(facetsForm);
                    appendChatHtml(facetsForm, messageTemplate, messageData);
                }, typingTime);
            } else {
                appendChatHtml(facetsForm, messageTemplate, messageData);
            }

            //load choice container
            if (type == "glasses-choice-container") {
                initGlassesChoiceContainer();
            }

            if (type == "shape-choice-container") {
                initShapeChoiceContainer();
            }

            //template functions
            function appendChatHtml(container, messageTemplate, messageData) {
                if (!messageData) {
                    messageData = [{}];
                }
                $(container).append(messageData.map(function (property) {
                    return messageTemplate.map(render(property)).join('');
                }));

                function render(props) {
                    return function (tok, i) {
                        return (i % 2) ? props[tok] : tok;
                    };
                }
            }

            function removeTypingHtml(container) {
                $(container).children(selectors.typing).remove();
            }

            if ($(selectors.chatContainer).length >= 1) {
                $(selectors.chatContainer).scrollTop($(selectors.chatContainer)[0].scrollHeight - $(selectors.chatContainer)[0].clientHeight);
            }
        }

        function addFilters($choiceContainer) {
            let $filters = $choiceContainer.last().find("[data-filtering]").last();
            $choiceContainer.last().find(selectors.choiceContainer.item).each((i, item) => {
                $(item).append($filters.find(".filter-group-display__list-item").clone());
                let filterFor = $(item).find("[data-glasses-item-text]").text().replace(/\n/g, '');
                $(item).find(`input`).each((j, filter) => {
                    TRY_ON_DEBUG && console.log(filterFor, filter);
                    if ($(filter).val().replace(/\s/g, '').toLowerCase() != filterFor.toLowerCase().replace(/\s/g, '')) {
                        console.warn("remove");
                        $(filter).parent().remove();
                    }
                });
            });
        }

        function showChatImages(condition, img) {
            if (condition && img) {
                const svgSerializer = new XMLSerializer();
                img = svgSerializer.serializeToString(img);
                return "<div class='glasses-item-img'>" + img + "</div>";
            }
            return '';
        }

        //TODO: refactor this and shape
        function initGlassesChoiceContainer() {
            let collectionsTitles = $(selectors.collections).find("[data-collections-title]").text().split("|");
            collectionsTitles = collectionsTitles.map(title => title.replace(/\n/g, ''));
            let collectionsImages = $(selectors.collections).find("[data-icon] svg");
            let $choiceContainer = $(selectors.choiceContainer.parent);

            //TODO: template
            for (let i = 0; i < collectionsTitles.length; i++) {
                if (collectionsTitles[i].replace(/ /g, '')) {
                    $choiceContainer.find(selectors.choiceContainer.itemWrapper).last().append(`
                    <div class="slide--custom-initial">
                        <div id=${Math.floor(Math.random() * 100)} class="glasses-item" data-glasses-item>
                        <svg width="28" height="27" viewBox="0 0 28 27" fill="none" xmlns="http://www.w3.org/2000/svg" class="selected-tick">
                            <path d="M13.7391 0C6.16306 0 0 6.0558 0 13.5C0 20.9442 6.16306 27 13.7391 27C21.3152 27 27.4782 20.9442 27.4782 13.5C27.4782 6.0558 21.3152 0 13.7391 0Z" fill="#3C7A75"/>
                            <path d="M20.7951 10.3934L13.1951 18.3341C12.967 18.5723 12.6677 18.6922 12.3684 18.6922C12.0691 18.6922 11.7698 18.5723 11.5418 18.3341L7.7419 14.3637C7.2846 13.8861 7.2846 13.1139 7.7419 12.6363C8.19899 12.1585 8.93782 12.1585 9.39513 12.6363L12.3684 15.743L19.1419 8.66598C19.599 8.18816 20.3378 8.18816 20.7951 8.66598C21.2522 9.14357 21.2522 9.91554 20.7951 10.3934Z" fill="white"/>
                        </svg>
                            ${showChatImages(Boolean(shopifyData.showChatImages), collectionsImages[i])}
                            <p data-glasses-item-text>${collectionsTitles[i]}</p>
                        </div >
                        </div >
                    </div >
                    `);
                }
            }


            //append filters
            addFilters($choiceContainer);

            $choiceContainer.find(selectors.choiceContainer.itemWrapper).slick({
                variableWidth: true,
                // centerMode: true,
                infinite: false
            });

            $choiceContainer.find(selectors.choiceContainer.item).on("click", selectGlasses);

            function selectGlasses() {
                $(this).toggleClass("selected");
                addChatMessageWithDelay("normal", [{ text: shopifyData.findGlassesMessage }], true, 0, 0);

                $choiceContainer.find(selectors.choiceContainer.item).off('click', selectGlasses);
                $choiceContainer.find(selectors.choiceContainer.item).css('pointer-events', "none");

                if(shopifyData.showGlassesShape == 'true') {
                    addChatMessageWithDelay("shape-choice-container", null, null, 0, 2000);
                } else {
                    showChat(2000,1000);
                }
            }
        }

        function initShapeChoiceContainer() {

            //TODO: Shapes imgs
            let collectionsTitles = $(selectors.collectionsShape).find("[data-collections-title]").text().split("|");
            let $choiceContainer = $(selectors.choiceContainer.parent);
            let collectionsImages = $(selectors.collectionsShape).find("[data-icon] svg");

            //TODO: template

            for (let i = 0; i < collectionsTitles.length; i++) {
                if (collectionsTitles[i].replace(/ /g, '')) {
                    $choiceContainer.find(selectors.choiceContainer.itemWrapper).last().append(`
                    <div class="slide--custom-initial">
                            <div class="glasses-item" data-glasses-item>
                                <svg width="28" height="27" viewBox="0 0 28 27" fill="none" xmlns="http://www.w3.org/2000/svg" class="selected-tick">
                                    <path d="M13.7391 0C6.16306 0 0 6.0558 0 13.5C0 20.9442 6.16306 27 13.7391 27C21.3152 27 27.4782 20.9442 27.4782 13.5C27.4782 6.0558 21.3152 0 13.7391 0Z" fill="#3C7A75"/>
                                    <path d="M20.7951 10.3934L13.1951 18.3341C12.967 18.5723 12.6677 18.6922 12.3684 18.6922C12.0691 18.6922 11.7698 18.5723 11.5418 18.3341L7.7419 14.3637C7.2846 13.8861 7.2846 13.1139 7.7419 12.6363C8.19899 12.1585 8.93782 12.1585 9.39513 12.6363L12.3684 15.743L19.1419 8.66598C19.599 8.18816 20.3378 8.18816 20.7951 8.66598C21.2522 9.14357 21.2522 9.91554 20.7951 10.3934Z" fill="white"/>
                                </svg>   
                                ${showChatImages(Boolean(shopifyData.showChatImages), collectionsImages[i])}
                                <p data-glasses-item-text>${collectionsTitles[i]}</p>
                                </div>
                            </div >
                        </div>
                    `);
                }
            }

            //append filters
            addFilters($choiceContainer);

            //init slick
            $choiceContainer.last().find(selectors.choiceContainer.itemWrapper).slick({
                variableWidth: true,
                // centerMode: true,
                infinite: false
            });

            //events
            $choiceContainer.last().find(selectors.choiceContainer.item).on("click", selectShape);

            function selectShape() {
                $(this).toggleClass("selected");

                addChatMessageWithDelay("normal", [{ text: shopifyData.findShapeMessage }], true, 1000, 1000);
                $choiceContainer.find(selectors.choiceContainer.item).off('click', selectShape);
                $choiceContainer.find(selectors.choiceContainer.item).css('pointer-events', 'none');

                showChat(2000,3000);
            }
        }

        function showChat(typingTime, delay) {
            addChatMessageWithDelay("normal", [{ text: shopifyData.launchMessage }], true, typingTime, delay);
            // show fitmix
            $("#my-fitmix-container").show();

            //Start the app
            setTimeout(() => {
                initFitMix();
                toggleIntroModal();
                // toggleAllowCameraModal();

                $(selectors.chatContainer).hide();
                $(selectors.chatContainer).find(selectors.choiceContainer.parent).remove();
                $(".fittingbox-product-list-wrapper").show();
            }, delay+5000);
        }

        var fittingboxContainerWrapper = document.querySelector(".fittingbox-container-wrapper");
        var fitmixWrapper = document.querySelector(".fittingbox-container-wrapper .fitmix-wrapper");
        var fittingboxProductListWrapper = document.querySelector(".fittingbox-product-list-wrapper");
        var fittingboxFilter = document.querySelector(".fittingbox-filter");
        var fittingboxProductList = document.querySelector(".fittingbox-product-list");

        var get_lang = document.querySelector("html").getAttribute("lang");
        if (get_lang == "da") {
            get_lang = "da-dk";
        } else if (get_lang == "nb") {
            get_lang = "no";
        }

        var params = {
            apiKey: 'FKKyiL0aNESWKAlx1UDeYGlJY6Yw6RQ2o7J7pjXt',
            liveAutostart: true,
            mode: "live",
            lang: get_lang,
            watermark: false,
            onAgreePrivacyTerms: onAgreePrivacyTerms,
            onPrivacyTermsShown: onPrivacyTermsShown
        };

        function onPrivacyTermsShown() {
            terms_agreed = false;
            $(".fittingbox-cam-content").css("z-index", "-1");
            $(".fittingbox-product-list").css("z-index", "-1");
        }
        function onAgreePrivacyTerms() {
            terms_agreed = true;
            $(".fittingbox-cam-content").css("z-index", "unset");
            $(".fittingbox-product-list").css("z-index", "unset");
        }

        if (terms_agreed) {
            $(".fittingbox-cam-content").css("z-index", "unset");
            $(".fittingbox-product-list").css("z-index", "unset");
        } else {
            $(".fittingbox-cam-content").css("z-index", "-1");
            $(".fittingbox-product-list").css("z-index", "-1");
        }

        var fittingboxCamContents = document.querySelectorAll(".fittingbox-product-card .fittingbox-cam-content");
        var fittingboxFilterBtn = document.querySelector(".fittingbox-filter-btn");

        for (var i = 0; i < fittingboxCamContents.length; i++) {
            fitmixWrapper.append(fittingboxCamContents[i]);
        }

        function onFitMixReady() {
            var fittingboxProductList = document.querySelector(".fittingbox-product-list");
            if (fittingboxProductList) {
                dragElement(fittingboxProductList);
            }

            if (!initOnlyFitmix) {
                addFilterEvents(".fittingbox-filter-popup");
            }
            addHoldingEvents(".fittingbox-product-card");
            initAddToCartPopup(
                "[data-add-to-cart]",
                "[data-qty-btn]",
                "[data-add-to-cart-popup]",
                "[data-add-to-cart-close]",
                true
            );

            let initialFrame = $("#try-on-drawer").data("initial-frame");
            if (initialFrame) {
                fitmixInstance.setFrame(initialFrame);
            }

            function b(e) {
                var clicked = false;

                if (!clicked) {
                    if (!e.target.classList.contains('color_swatch-selected')) {
                        let productId = e.target.getAttribute('data-main-id');
                        if (productId) {
                            let frame = e.target.getAttribute('data-frame');

                            fitmixInstance.setFrame(frame);

                            onColorSwatchClick(e);

                            clicked = true;
                        }
                    }
                }
            }

            $("#fittingbox-collection-page").on("click", ".color_swatch-select", b);
            $(".fittingbox-select").on("click", onProductClick);
        }

        document.addEventListener("try-on-close", function (e) {
            fitmixInstance.remove();
            $(".fittingbox-cam-content").css("z-index", "-1");
            $(".fittingbox-product-list").css("z-index", "-1");
        });
        document.addEventListener("try-on", initFitMix);

        if (initFitmixInstance) {
            ifMobile();
        }
        window.onresize = function () {
            ifMobile();
        }

        function addFilterEvents(fittingboxFilterPopup) {
            $('.fittingbox-filter-btn').off("click", toggleFittingbox);
            $(".fittingbox-filter-btn").on("click", toggleFittingbox);
            function toggleFittingbox() {
                $(fittingboxFilterPopup).toggle();
            }
        }

        function onColorSwatchClick(e) {
            var event_target = e.target;
            var colorSwatches = event_target.closest(".color-selection").querySelectorAll("a");
            var colorSwatch = event_target.closest("a");
            var colorSwatchImages = event_target.closest(".color-selection").querySelectorAll("img.color_swatch-select");
            var productId = event_target.getAttribute("data-id");
            var productMainId = event_target.getAttribute("data-main-id");
            var productTitle = event_target.getAttribute("data-title");
            var productPrice = event_target.getAttribute("data-price");
            var productFrame = event_target.getAttribute("data-frame");
            var productHandle = event_target.getAttribute("data-handle");
            var productImg = event_target.getAttribute("data-img");
            var productVariantId = event_target.getAttribute("data-variant-id");
            var productTitleEle = event_target.closest(".fittingbox-cam-content").querySelector(".fittingbox-product-title");
            var productPriceEle = event_target.closest(".fittingbox-cam-content").querySelector(".fittingbox-cam-product-price");
            var productVariantIdEle = event_target.closest(".fittingbox-cam-content").querySelector("input[name='id']");

            for (var i = 0; i < colorSwatches.length; i++) {
                colorSwatches[i].classList.remove("selected");
            }
            colorSwatch.classList.add("selected");

            for (var i = 0; i < colorSwatchImages.length; i++) {
                colorSwatchImages[i].classList.remove("color_swatch-selected");
            }
            event_target.classList.add("color_swatch-selected");

            productTitleEle.innerHTML = productTitle;
            productPriceEle.innerHTML = Utils.formatMoney(productPrice / 100);
            productVariantIdEle.setAttribute("value", productVariantId);

            // product items in mobile/tablet devices
            var productImageEle = document.querySelector(`.fittingbox-container-wrapper .fittingbox-product-image[data-main-id="${productMainId}"`);
            if (productImageEle) {
                productImageEle.setAttribute("data-id", productId);
                productImageEle.setAttribute("data-frame", productFrame);
                productImageEle.setAttribute("srcset", productImg);
            }

            sendTrackingEvents(productMainId, productTitle);

            console.warn(productHandle);
            $.getJSON(`/products/${productHandle}.js`, function (product) {
                return product;
            }).then((product) => {
                onColorSwatchChangePopup(product, event_target);
            });
        }

        function initFitMix() {
            fitmixInstance = FitMix.createWidget('my-fitmix-container', params, onFitMixReady);
        }

        function ifMobile() {
            if (window.innerWidth <= MOBILE_MAX_SIZE) {
                fittingboxContainerWrapper && fittingboxContainerWrapper.append(fittingboxFilter);
                if (initFitmixInstance) {
                    fitmixWrapper && fitmixWrapper.append(fittingboxProductList);
                }
                return true;
            } else {
                fittingboxFilter && fittingboxFilter.prepend(fittingboxFilterBtn);
                fittingboxProductListWrapper && fittingboxProductListWrapper.append(fittingboxProductList);
                return false;
            }
        }
        //cart popup

        // Fittingbox onClick function
        function onProductClick(e) {
            var fittingboxProductCard = document.getElementsByClassName("fittingbox-product-card");
            var clicked = false;
            var event_target = e.target;

            if (!clicked) {
                if (!event_target.classList.contains('fittingbox-selected')) {

                    $("[data-add-to-cart-popup]").hide();

                    let mainProductId = event_target.getAttribute('data-main-id');
                    let productId = event_target.getAttribute('data-id');
                    let productTitle = event_target.getAttribute('data-title');
                    if (mainProductId && fittingboxProductCard.length > 1) {
                        let frame = event_target.getAttribute('data-frame');
                        let handle = event_target.getAttribute('data-handle');
                        let frameCard = document.querySelector(".fittingbox-product-card#frame-" + mainProductId);
                        var fittingboxCamContent = document.querySelector("#cam-" + mainProductId + ".fittingbox-cam-content");

                        fitmixInstance.setFrame(frame);

                        $(".fittingbox-select").removeClass("fittingbox-selected");
                        event_target.classList.add("fittingbox-selected");

                        $(".fittingbox-product-card").removeClass("frame-selected");
                        frameCard.classList.add("frame-selected");

                        $(".fittingbox-container-wrapper .fittingbox-cam-content").hide();
                        if (fittingboxCamContent) {
                            fittingboxCamContent.style.display = "block";
                        }
                        getColorSwatch(productId, handle);
                        sendTrackingEvents(productId, productTitle);
                        clicked = true;
                    }
                }
            }
        }

        function addHoldingEvents(target) {

            let onLongTouch;
            let timer;
            let touchDuration = 500; //length of time we want the user to touch before we do something

            if (ifMobile()) { //mobile
                $(target).off("touchstart", touchstart);
                $(target).off("touchend", touchend);
                $(target).on("touchstart", touchstart);
                $(target).on("touchend", touchend);
            } else { //desktop
                $(".fittingbox-cam-bottom input[type='submit']").off("click", showPopup);
                $(".fittingbox-cam-bottom input[type='submit']").on("click", showPopup);

                function showPopup(e) {
                    $("[data-add-to-cart-popup]").show();
                    $("[data-add-to-cart-popup-2]").hide();
                    $("[data-add-to-cart-popup").find(".strength-box.selected").each((box) => $(box).removeClass("selected"));
                    $("[data-add-to-cart-advance]").addClass("disabled");
                    $("[data-add-to-cart-popup]").find("[data-error-text]").hide();
                    e.preventDefault();
                }
            }

            function touchstart(e) {
                $(e.target).parents(".fittingbox-product-card").addClass("adding-to-cart");
                $("[data-add-to-cart-popup]").hide();
                $("[data-add-to-cart-popup-2]").hide();
                if (!timer) {
                    timer = setTimeout(onLongTouch, touchDuration);
                }
            }

            function touchend(e) {
                //stops short touches from firing the event
                if (timer) {
                    $(e.target).parents(".fittingbox-product-card").removeClass("adding-to-cart");
                    clearTimeout(timer);
                    timer = null;
                }
            }

            onLongTouch = function () {
                timer = null;
                $("[data-add-to-cart-popup]").show();
                $("[data-add-to-cart-advance]").addClass("disabled");
                $(target).removeClass("adding-to-cart");
            };
        }

        function dragElement(elmnt) {
            let startX, scrollLeft;
            let isDown = false;
            elmnt.onmousedown = dragMouseDown;

            function dragMouseDown(e) {
                e = e || window.event;
                e.preventDefault();
                isDown = true;

                startX = e.pageX - elmnt.offsetLeft;
                scrollLeft = elmnt.scrollLeft;

                document.onmousemove = elementDrag;
                document.onmouseup = closeDragElement;
            }

            function elementDrag(e) {
                if (!isDown) return;
                e = e || window.event;
                e.preventDefault();

                const x = e.pageX;
                const walk = (x - startX);
                elmnt.scrollLeft = scrollLeft - walk;
            }

            function closeDragElement(e) {
                isDown = false;
                document.onmouseup = null;
                document.onmousemove = null;
            }
        }

        var asset_url_0 = boostPFSAppConfig.general.asset_url.split("?")[0].replace("boost-pfs.js", "");
        var asset_url_1 = boostPFSAppConfig.general.asset_url.split("?")[1];

        function getColorSwatch(productId, handle) {
            var html = "";
            var product_src = "";
            var product_frame = "";
            var product_handles = [];
            var ajax_loading_src = asset_url_0 + "ajax-load.gif" + "?v=" + asset_url_1;

            $(`#cam - ${productId} .color - selection`).html(` < img src = "${ajax_loading_src}" /> `);

            async function getHandles() {
                let response = await fetch(`https://netlify.blacklemon.dk/.netlify/functions/getProductMetafields?store=${Shopify.shop.split('.')[0]}&productId=${productId}`);
                let data = await response.json();
                data.metafields.map(metafield => {
                    if (metafield.key == "connected_products") {
                        product_handles = metafield.value.split("|");
                    }
                });

                product_handles.push(handle);
                return product_handles;
            }
            async function buildColorSwatches(product) {
                let response = await fetch(`https://netlify.blacklemon.dk/.netlify/functions/getProductMetafields?store=${Shopify.shop.split('.')[0]}&productId=${product.id}`);
                let data = await response.json();

                data?.metafields.map(metafield => {
                    if (metafield.namespace == "accentuate" && metafield.key == "color") {
                        product_src =
                            asset_url_0 +
                            "color_" +
                            metafield.value.replace(/\s/g, '') +
                            ".png?v=" +
                            asset_url_1;
                    }
                    if (metafield.key == "fittingbox_frame_id") {
                        product_frame = metafield.value;
                    }
                });

                if (product_src) {
                    var flip_image = "";
                    if (product.images.length > 1) {
                        var flip_image = product.images[1];
                    }

                    if (productId == product.id) {
                        var selected = true;
                    } else {
                        var selected = false;
                    }

                    html = `<a class="${selected ? 'selected' : ''}">` +
                        `<img class="color_swatch color_swatch-select"
                        src="${product_src}"
                        data-frame="${product_frame}"
                        data-id="${product.id}"
                        data-main-id="${productId}"
                        data-variant-id="${product.variants[0].id}"
                        data-title="${product.title}"
                        data-price="${product.price}"
                        data-handle="${product.handle}"
                        data-url="${product.url}"
                        data-img="${product.featured_image}"
                        data-flip-img="${flip_image}"
                         />` +
                        `</a>`;
                    $(`#cam-${productId} .color-selection`).append(html);
                }
            }

            try {
                getHandles().then(product_handles => {
                    const handles = product_handles;

                    handles.forEach(handle => {
                        $.getJSON(`/products/${handle}.js`, function (product) {
                            buildColorSwatches(product);
                        });
                    });
                    $(`#cam-${productId} .color-selection`).empty();
                });
            } catch (error) {
                TRY_ON_DEBUG && console.log(error);
            }
        }
    }

    function sendTrackingEvents(productId, productTitle) {
        fbq(
            'trackCustom', 'Try on', {
            content_name: productTitle,
            content_ids: [productId],
            content_type: 'product',
            currency: theme.shop.currency
        });

        let fbTrackingUrl = `https://netlify.blacklemon.dk/.netlify/functions/facebookTracking?storeCurrency=${theme.settings.currency}&prodVal=${0}&prodQuant=${1}&prodId=${productId}`;
        $.ajax({
            url: fbTrackingUrl,
            type: "GET",
            crossDomain: true,
            success: function (response) {
                console.warn('Tracking event success: ', response);
            },
            error: function (xhr, status) {
                console.warn('Tracking event error: ', xhr, status);
            }
        });

        ga('send', {
            hitType: 'event',
            eventCategory: 'Engagement',
            eventAction: 'Try on',
            eventLabel: productTitle
        });
    }



    function onColorSwatchChangePopup(product, colorSwatch) {

        const popupWrapper = $(colorSwatch).parent().parent().parent().siblings(".add-to-cart-popup-wrapper");
        const popup1 = $(popupWrapper).find("[data-add-to-cart-popup]");

        $(popup1).hide();
        $(popup1).find("[data-product-variants]").empty();

        for (variant of product.variants) {
            let unavailableClass = "";
            if (variant.available != true) {
                unavailableClass = "unavailable";
            }
            $(popup1).find("[data-product-variants]").append(`
                <div class="strength-box ${unavailableClass}" data-variant-id="${variant.id}" >${variant.title}</div>
            `).clone();
        }

        $(popup1).find("[data-product-title]").text(product.title);
        $(popup1).find("[data-product-type]").text(product.type);

        if (product.featured_image) {
            $(popup1).find("[data-product-image]").attr("srcset", product.featured_image);
        }

        $(popup1).find("[data-product-price]").text(Utils.formatMoney(product.price / 100));
        $(popup1).find("[data-qty]").val(1);
        $(popup1).find("[data-qty-dec]").addClass("unavailable");

        if (initOnlyFitmix) {
            initAddToCartPopup(
                "[data-add-to-cart]",
                "[data-qty-btn]",
                "[data-add-to-cart-popup]",
                "[data-add-to-cart-close]",
                false
            );
        }
    }
}

tryOnInit();
window.tryOnInit = tryOnInit;

/** Old functions **/

// function initModal() {
//     $(".allow-permission-container").find(".feather-x").on("click", toggleAllowCameraModal);
// }

// function toggleAllowCameraModal() {
//     $(".allow-permission-container").toggle();
// }
